import React from 'react'
import { ChevronDown, ChevronUp } from 'lucide-react'
import { CircularCollapseIcon, CollapsibleHeader, Title } from './CollapsibleSectionHeader.style'

interface CollapsibleSectionHeaderProps {
  title: React.ReactNode
  isOpen: boolean
  onToggle: () => void
}

const CollapsibleSectionHeader = ({ title, isOpen, onToggle }: CollapsibleSectionHeaderProps): React.ReactElement => (
  <CollapsibleHeader onClick={onToggle}>
    <Title>{title}</Title>
    <CircularCollapseIcon>
      {isOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
    </CircularCollapseIcon>
  </CollapsibleHeader>
)

export default CollapsibleSectionHeader
